import request from "root/js/request";

export const getWBCabinets = async () => {
  const response = await request({
    url: "/company/wb_cabinets/",
    method: "get",
  });
  return response.data;
};
